import script from "./WalletUser.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletUser.vue?vue&type=script&setup=true&lang=js"

import "./WalletUser.vue?vue&type=style&index=0&id=7d4d9339&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4d9339"]])

export default __exports__